import { lookup } from 'mime-types';

export type MimeTypeMap = {
    [key in string]: string[];
};

export function getFileType(file: { name: string; type: string }) {
    // In IE11 the file type is not always filled in
    // https://stackoverflow.com/questions/32849014/ie-11-and-ie-edge-get-file-type-failed
    let result = file.type;
    if (!result) {
        const mimeType = lookup(file.name);
        if (mimeType) {
            result = mimeType;
        }
    }

    return result;
}

export function mapExtensionsToMimeTypes(extensions: string): MimeTypeMap {
    const result: MimeTypeMap = {};
    extensions.split(',').forEach((extension) => {
        const mimeType = lookup(extension);
        if (!mimeType) {
            return;
        }

        if (result[mimeType]) {
            result[mimeType].push(extension);
        } else {
            result[mimeType] = [extension];
        }
    });

    return result;
}
